module.exports = require("json-schema-ref-parser");